<!-- eslint-disable no-console -->
<template>
   <div>
      <file-importer-view @save-transactions="saveTransactions" :LastImportedTransactions="lastImportedTransactions" />   
   </div>
</template>

<script lang="ts">
import Vue from "vue";
import { apiPost,apiGet } from "../../dal";
import FileImporterView from "./views/FileImporterView.vue";

export default Vue.extend({
   name: "ImportView",
   components: { FileImporterView },
   props: {},
   data() {
      return {
         lastImportedTransactions: [],
      };
   },

   activated() {},

   mounted() {
      this.getLastImportedTransactions();
   },

   deactivated() {},

   computed: {
     
   },

   methods: {

      getLastImportedTransactions() {
         apiGet("import/getExistingTransactions/2").then((response) => {
            if (response != null) {               
               this.lastImportedTransactions = response;
            }
         });
      },

      saveTransactions(transactionData){
         const dbTransactionData = transactionData.map((transaction) => {
            return {
               TRA_DATE: transaction.date,
               TRA_AMOUNT: transaction.amount,
               TRA_TEXT: transaction.text,
               TRA_ACCOUNT: transaction.bankAccount,
               TRA_REF: transaction.ref,
               TRA_BANK_ID: transaction.fieldId,  
               TRA_TYPE: transaction.type,             
            };
         });         
         apiPost("db/transactions", dbTransactionData).then((response) => {
            if (response != null) {
              this.getLastImportedTransactions();
            }
         });
     
      }
     
   },
});
</script>

<style scoped>

</style>
